import React from 'react';

function GlossaryItem({ term, color, def }) {
  const colors = { orange: '#92700C', gold: '#92700C', yellow: '#92700C', blue: '#2563EB', green: '#16A34A', red: '#DC2626', purple: '#7C3AED', cyan: '#0891B2', pink: '#DB2777' };
  const c = colors[color] || '#525252';
  return (<div className="p-3" style={{ background: '#F5F5F5', border: '1px solid #E5E5E5', borderRadius: '4px' }}>
    <h4 className="font-semibold text-xs mb-0.5" style={{ color: c }}>{term}</h4>
    <p className="text-xs" style={{ color: '#525252', fontWeight: 300 }}>{def}</p>
  </div>);
}

export default GlossaryItem;
